import Meta from '@/utils/RouterMeta'
import Router from '@/utils/Router'
import {importers} from "~/router/private/crud";

const child = [
    //terminals
    Router.instance({
        path: 'terminals',
        name: 'terminals',
        component: () => import('@/pages/terminal/index'),
        meta: Meta.instance({
            btnName: 'Нефтебазы',
            icon: 'mdi-oil',
            title: 'Нефтебазы',
            appendBtn: true,
            permissions: ['admin','moderator']
        })
    }),
    Router.instance({
        path: '/terminal/:id?',
        name: 'terminal',
        props: true,
        component: () => import('@/pages/terminal/test'),
        meta: Meta.instance({
            title: 'Нефтебазы',
            show: false,
            permissions: ['admin','moderator']
        })
    }),
    //products
    Router.instance({
        path: 'products',
        name: 'nomenclature',
        component: () => import('@/pages/product/index'),
        meta: Meta.instance({
            btnName: 'Продукты',
            icon: 'mdi-tournament',
            title: 'Продукты',
            permissions: ['admin','moderator']
        })
    }),
    Router.instance({
        path: '/product/:id?',
        name: 'product',
        props: true,
        component: () => import('@/pages/product/createOrUpdate'),
        meta: Meta.instance({
            title: 'создать продукт',
            show: false,
            permissions: ['admin','moderator']
        })
    }),

    ...importers
]

export const incoming = [
    Router.instance({
        meta: Meta.instance({
            btnName: 'ПРИХОД',
            icon: 'mdi-playlist-check',
            title: 'ПРИХОД',
            permissions: ['admin','moderator']
        }),
        children: child
    })
]
